import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AutorunComponent} from '@myshared/autorun.component';
import {Model} from '../../app.model';
import { Router } from '@angular/router';

@Component({
    selector: 'app-phonenumber',
    templateUrl: './phonenumber.component.html',
    standalone: false
})
export class PhonenumberComponent extends AutorunComponent implements OnInit {

  @Output() public selected = new EventEmitter<string>();
  @Output() public back = new EventEmitter<void>();

  @Input() public hideBackButton = false;
  @Input() public trialPhonenumber: string;
   
  public tenantCountryCode: string;

  readonly PC_ONE_NEW_NUMBER = 'PC-ONE-NEW-NUMBER';

  accepted: boolean;
  public phonenumber: string;

  public isRetroactiveWorkflow = false;

  constructor(private m: Model, private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.isRetroactiveWorkflow = this.router.url.includes("completed")
    this.autorun(() => {
      // search for a phone number on the order
      this.phonenumber = this.getPhonenumber();
      this.tenantCountryCode = this.m.account.currentUser.trunkEnvironment.tenantCountryCode;
    });
  }

  accept(v: boolean) {
    this.accepted = v;
  }

  done() {
    this.router.navigate(['subscriptions']).then(() => 
      window.location.reload());
  }

  onBuy() {
    this.selected.emit('');
  }

  /**
   * Get a single phone number after reservation
   *
   * Fallback situation: When it comes to a side refresh, we will loose the block number data, in this case
   * we will parse the string text on the order lines.
   */
  getPhonenumber(): string {
    return this.trialPhonenumber
    || this.m.buy.currentOrder.lines
      .find(line => line.product === this.PC_ONE_NEW_NUMBER)
      ?.name.match(/(\d+)/)?.[0]
    || '';
  }

  public backEmitted() {
    this.back.emit();
  }

  public get testPhoneNumberHint() {
    const tenantCountryCode = this.tenantCountryCode.toLowerCase();
    return `test_phonenumber_hint_${tenantCountryCode}`;
  }

  public get acceptTermsText() {
    const tenantCountryCode = this.tenantCountryCode.toLowerCase();
    return `test_phonenumber_accept_terms_${tenantCountryCode}`;
  }

}
